import Badge from '@adsk/alloy-react-badge';
import Theme from '@adsk/alloy-react-theme';

export const Statuses = {
  OPEN: 'open',
  ONGOING: 'ongoing',
  ON_HOLD: 'on-hold',
  CLOSED: 'closed',
  INFORMATION: 'information',
};

export const colorByMeetingItemStatus = {
  [Statuses.OPEN]: Badge.COLORS.YELLOW,
  [Statuses.ONGOING]: Badge.COLORS.BLUE,
  [Statuses.ON_HOLD]: Badge.COLORS.RED,
  [Statuses.CLOSED]: Badge.COLORS.GRAY_200,
  [Statuses.INFORMATION]: Theme.colors.turquoise500,
};
